import React, { useEffect, useRef } from "react";
import './customMouse.css'

const HoverEffect: React.FC = () => {
  const cursorRef = useRef<HTMLDivElement | null>(null);

  const animateIt = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const span = e.currentTarget.querySelector('span') as HTMLSpanElement;
  
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
  
    const { offsetWidth: width, offsetHeight: height } = e.currentTarget;
  
    const move = 25;
    const xMove = (x / width) * (move * 2) - move;
    const yMove = (y / height) * (move * 2) - move;
  
    span.style.transform = `translate(${xMove}px, ${yMove}px)`;
  
    if (e.type === 'mouseleave') {
      span.style.transform = '';
    }
  };

  const editCursor: (this: Window, e: MouseEvent) => void = e => {
    const { clientX: x, clientY: y } = e;
    if (cursorRef.current) {
      cursorRef.current.style.left = x + 'px';
      cursorRef.current.style.top = y + 'px';
    }
  };

  useEffect(() => {
    const links = document.querySelectorAll('nav > .hover-this');
  
    links.forEach(link => {
      link.addEventListener('mousemove', animateIt as unknown as EventListener);
      link.addEventListener('mouseleave', animateIt as unknown as EventListener);
    });

    window.addEventListener('mousemove', editCursor);
  
    return () => {
      links.forEach(link => {
        link.removeEventListener('mousemove', animateIt as unknown as EventListener);
        link.removeEventListener('mouseleave', animateIt as unknown as EventListener);
      });

      window.removeEventListener('mousemove', editCursor);
    };
  }, []);

  return (
    <div className="cursor" ref={cursorRef}>
      <p className="hover-this">
      <span></span>
      </p>
      
      {/* Your JSX for the component */}
      {/* <nav>
        <a href="#" className="hover-this">
          <span>Your Content</span>
        </a> */}
        {/* Add more links as needed */}
      {/* </nav> */}
      

    </div>
  );
};

export default HoverEffect;
